"use client";

import { useState, useEffect } from "react";
import * as myApi from "../Api";

const Footer = () => {
  const [dbInfo, setDbInfo] = useState(null);
  const [envInfo, setEnvInfo] = useState(null);

  // Check if development environment
  const apiUrl = window.env?.API_URL || '';
  const isDevelopment = apiUrl.includes('localhost') || 
                        apiUrl.includes('127.0.0.1') || 
                        apiUrl.includes(':3001') ||
                        process.env.NODE_ENV === 'development';

  const isAuthenticated = myApi.checkUserActive();

  // Fetch database and environment info (only in non-production)
  useEffect(() => {
    if (isDevelopment) {
      // Get DB info
      myApi.get('/db-info')
        .then((response) => {
          if (response.data && response.data.data) {
            setDbInfo(response.data.data);
          }
        })
        .catch((error) => {
          console.log('DB info not available:', error.message);
        });

      // Set environment info
      setEnvInfo({
        apiUrl: apiUrl,
        nodeEnv: process.env.NODE_ENV || 'development'
      });
    }
  }, [isDevelopment, apiUrl]);
  
  return (
    <>
      <div className="flex-grow-1"></div>

      <footer className={"footer-area bg-white text-center rounded-top-7 " + (isAuthenticated ? "sticky-bottom" : "d-none")}>
        <p className="fs-14 mb-1">
          © <span className="text-primary-div">2026</span> Submission System by {" "}
          <a
            href="https://ejavec.org/"
            target="_blank"
            rel="noreferrer"
            className="text-decoration-none text-primary"
          >
            East Java Economic (EJAVEC)
          </a>
        </p>

        {isDevelopment && (
          <p className="fs-10 text-muted mt-1 mb-1">
            <span className="badge bg-danger text-white me-2">Local Development</span>
            {envInfo && (
              <span className="me-2">
                <i className="material-symbols-outlined fs-9 align-middle me-1">settings</i>
                ENV: <strong>{envInfo.nodeEnv}</strong>
              </span>
            )}
            {dbInfo && (
              <span>
                <i className="material-symbols-outlined fs-9 align-middle me-1">database</i>
                <strong>{dbInfo.host}:{dbInfo.port}</strong> / {dbInfo.name}
              </span>
            )}
          </p>
        )}
      </footer>
    </>
  );
};

export default Footer;
